import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiAxios } from '@/lib/apiAxios';
const fetchPatterns = async () => {
    const response = await apiAxios.get('/page-designs/patterns');
    return response.data;
};
/**
 * The pattern catalog is static (server-side const list), so we cache for
 * the lifetime of the SPA session. Same convention as system page-designs.
 */
export const usePageDesignPatterns = () => useQuery({
    queryKey: ['page-design-patterns'],
    queryFn: fetchPatterns,
    staleTime: Infinity,
});
const patchBackgroundPattern = async ({ publicId, backgroundPattern, }) => {
    const response = await apiAxios.patch(`/campaigns/${publicId}/background-pattern`, {
        backgroundPattern,
    });
    return response.data;
};
export const usePatchBackgroundPattern = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: patchBackgroundPattern,
        onSuccess: (_data, variables) => {
            // Invalidate the campaign so analytics + detail screens reflect
            // the new override on next render. Match the existing
            // patchPageDesign convention.
            queryClient.invalidateQueries({ queryKey: ['campaign', variables.publicId] });
            queryClient.invalidateQueries({ queryKey: ['campaigns'] });
        },
    });
};
const patchRandomBackgroundPattern = async ({ publicId, randomBackgroundPattern, }) => {
    const response = await apiAxios.patch(`/campaigns/${publicId}/random-background-pattern`, { randomBackgroundPattern });
    return response.data;
};
export const usePatchRandomBackgroundPattern = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: patchRandomBackgroundPattern,
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['campaign', variables.publicId] });
            queryClient.invalidateQueries({ queryKey: ['campaigns'] });
        },
    });
};
